import { render } from "./WhyPageWidePress.vue?vue&type=template&id=1fbe5997&scoped=true"
import script from "./WhyPageWidePress.vue?vue&type=script&lang=js"
export * from "./WhyPageWidePress.vue?vue&type=script&lang=js"

import "./WhyPageWidePress.vue?vue&type=style&index=0&id=1fbe5997&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbe5997"]])

export default __exports__